import { Dispatch, SetStateAction, useEffect } from "react";
import { RoundedFullCheck } from "../Icons";
import { AlertElement, AlertWrapper } from "./style";

export enum AlertType {
    Success = "success",
    Error = "error"
}

interface IProps {
    type?: AlertType;
    title: string;
    text: string;
    setShowAlert: Dispatch<SetStateAction<boolean>>;
}

export const Alert: React.FC<IProps> = ({
    type = AlertType.Success,
    title,
    text,
    setShowAlert
}) => {
    useEffect(() => {
        setTimeout(() => {
            setShowAlert(false);
        }, 8200);
    }, [setShowAlert]);
    return (
        <AlertElement>
            <AlertWrapper>
                {type === AlertType.Success && <RoundedFullCheck />}
                <div>
                    <p>{title}</p>
                    <small>{text}</small>
                </div>
            </AlertWrapper>
        </AlertElement>
    );
};
